import { render, staticRenderFns } from "./majorEventsReporting.vue?vue&type=template&id=01deb610&scoped=true"
import script from "./majorEventsReporting.vue?vue&type=script&lang=js"
export * from "./majorEventsReporting.vue?vue&type=script&lang=js"
import style0 from "./majorEventsReporting.vue?vue&type=style&index=0&id=01deb610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01deb610",
  null
  
)

export default component.exports